import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Heading from '../../components/Heading';
import AnnouncementsTable from '../../components/AnnouncementsTable';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { setSearch, clearSearch } from 'src/store/actions/search';
import { upload } from 'src/helpers/upLoadHelper';
import Loader from '../../components/Loader';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import {
  fetchAnnouncements,
  saveAnnouncement,
  deleteAnnouncement,
} from 'src/store/actions/Announcements';
import { selectAnnouncements } from 'src/store/selectors/Announcements';
import { getTenantName } from 'src/helpers/validationHelper';
import { stopLoaders } from 'src/store/actions/loader';

const Announcements = () => {
  const announcements = useSelector(selectAnnouncements);
  const user = useSelector(selectAuthenticatedUser);
  const loader = useSelector(selectPRLoader);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(stopLoaders());
    dispatch(clearSearch());
    dispatch(fetchAnnouncements(user.id, user.roles[0].role.name));
  }, [dispatch, user.id, user.roles]);

  const uploadimg = async (imgFile, callback) => {
    const imageUrl = await upload(imgFile);
    const object = {
      title: imageUrl.split('.com/')[1],
      url: imageUrl,
    };

    callback(object);
  };

  const handleMultipleUpload = async (selectedImage, callback) => {
    const uploadImages = [];

    for (let i = 0; i < selectedImage.length; i++) {
      if (selectedImage[i] && selectedImage[i].id) {
        uploadImages.push(selectedImage[i]);
      } else {
        await uploadimg(selectedImage[i], (imgData) => {
          uploadImages.push(imgData);
        });
      }
    }

    callback(uploadImages);
  };

  const handleSaveAnnouncement = async (data) => {
    const tenantName = getTenantName();
    let params = {};
    let imageUrl = [];

    if (data.attachments && data.attachments.length > 0) {
      await handleMultipleUpload(data.attachments, function (resObj) {
        imageUrl = resObj;
      });
    }

    params = {
      title: data.title,
      description: data.description,
      userId: user.id,
      propertyId: data.propertyId,
      attachments:
        imageUrl && imageUrl.length > 0 ? JSON.stringify(imageUrl) : '',
      IsBuilding: data.IsBuilding,
      IsLevel: data.IsLevel,
      AnnouncementBuildingLevels: data.AnnouncementBuildingLevels,
      AnnouncementSuites: data.AnnouncementSuites,
      tenant: tenantName,
    };

    dispatch(saveAnnouncement(params));
  };

  const handleDeleteAnnouncement = (data) => {
    dispatch(deleteAnnouncement(data.id));
  };

  const handleSearch = (e) => {
    dispatch(setSearch({ announcements: e.target.value.trim() }));
  };

  return (
    <>
      {loader && <Loader center={true} />}
      <WithNavigation
        title="Announcements"
        top={
          <Heading
            headline="Announcements"
            items={[
              {
                key: 'Announcements',
                value: announcements.length,
              },
            ]}
          />
        }
        bottom={
          <Tabs
            items={[
              {
                label: 'Announcements',
                length: announcements.length,
                content: (
                  <AnnouncementsTable
                    announcements={announcements}
                    onSaveAnnouncements={handleSaveAnnouncement}
                    onSearch={handleSearch}
                    onDeleteAnnouncement={handleDeleteAnnouncement}
                  />
                ),
              },
            ]}
          />
        }
      />
    </>
  );
};

export default Announcements;
